<template>
  <div>
    <Row :gutter="8" class="m-b-5">
      <i-col :xs="24" :sm="6" :md="3" :lg="3" class="m-b-5">
        <DatePicker size="small" transfer v-model="query.startDate"
          style="width: 100%" placement="top-start" placeholder="合同开始时间"></DatePicker>
      </i-col>
      <i-col :xs="24" :sm="6" :md="3" :lg="3" class="m-b-5">
        <DatePicker size="small" transfer v-model="query.endDate"
          style="width: 100%" placement="top-start" placeholder="合同开始时间"></DatePicker>
      </i-col>
      <i-col :xs="24" :sm="6" :md="3" :lg="3" class="m-b-5">
        <Select v-model="query.contractType" size="small" placeholder="合同类型" clearable>
          <Option
            v-for="(item, index) in contractTypeArray"
            :key="index"
            :value="item.key"
            >{{ item.value }}</Option
          >
        </Select>
      </i-col>
      <i-col :xs="24" :sm="6" :md="3" :lg="3" class="m-b-5">
        <Select
          v-model="query.status"
          size="small"
          placeholder="状态"
          clearable
        >
          <Option
            v-for="(item, index) in statusArray"
            :key="index"
            :value="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </i-col>
      <i-col :xs="24" :sm="6" :md="3" :lg="6" class="m-b-5">
        <i-input
          size="small"
          v-model="query.queryString"
          clearable
          placeholder="关键字：支持合同编号、名称"
        ></i-input>
      </i-col>
      <i-col :xs="24" :sm="6" :md="6" :lg="6" class="m-b-5">
        <Button
          size="small"
          type="primary"
          icon="ios-search"
          @click="SearchData"
          >搜索</Button
        >
        <Button
          size="small"
          type="success"
          icon="md-add"
          class="m-l-10"
          @click="handleCreateInvestment"
          >创建合同</Button
        >
        <Button
          size="small"
          type="success"
          icon="md-download"
          class="m-l-10"
          @click="handleExportContract"
          >导出合同清单</Button
        >
      </i-col>
    </Row>
    <Table
      size="small"
      :columns="columnManagedata"
      :data="tableData"
      :loading="tableLoading"
      stripe
    ></Table>
    <div class="paging_style">
      <Page
        size="small"
        :total="total"
        :page-size="query.pageSize"
        show-total
        show-elevator
        :current="query.pageNumber"
        @on-change="changePage"
      ></Page>
    </div>

    <CreateContract ref="CreateContractModal"></CreateContract>
  </div>
</template>

<script>

import CreateContract from './modalComponents/CreateContract.vue'
// apis
import { listContractInfo, deleteContract } from '@/api/invest/contract'
import { listDictLabel } from '@/api/invest/dict'
// utils
import { ParseDate } from '@/utils/dateFormat'
import { formatScContractStatus } from '@/utils/tagStatus'
import { downloadFileRequest } from '@/utils/download'

export default {
  components: {
    CreateContract
  },
  data () {
    return {
      statusArray: [],
      contractTypeArray: [
        { key: 1, value: '商业' },
        { key: 2, value: '通信' }
      ],
      investmentCreateModal: false,

      tableLoading: false,
      total: 0,
      query: {
        pageNumber: 1,
        pageSize: 15,
        endDate: null,
        startDate: null,
        status: null,
        contractType: null,
        queryString: ''
      },
      tableData: [],
      columnManagedata: [
        {
          title: '合同编号',
          key: 'code'
        },
        {
          title: '合同名称',
          key: 'name'
        },
        {
          title: '合同类型',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.contractType === 1 ? '商业' : '通信')
          }
        },
        // {
        //   title: '来源项目',
        //   key: 'investName'
        // },

        {
          title: '用途',
          key: 'purposeTypeName',
          align: 'center'
        },
        // { title: '甲方', key: 'companyName' },
        { title: '乙方', key: 'advertiserName' },
        { title: '客户类型', key: 'advertiserTypeName', align: 'center' },
        { title: '创建人', key: 'createUserName' },
        { title: '创建时间', key: 'createTime' },
        {
          title: '合同状态',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return formatScContractStatus(
              h,
              params.row.status,
              params.row.contractStatusName
            )
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 120,
          render: (h, params) => {
            const detailButton = h(
              'a',
              {
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$store.commit('set_contract_pageType', 'detail')
                    this.$store.commit('set_contract_id', params.row.id)
                    // this.handleShowDetail(params.row.id)
                  }
                }
              },
              '详情'
            )
            const editButton = h(
              'a',
              {
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$store.commit('set_contract_pageType', 'edit')
                    this.$store.commit('set_contract_currentStep', 'basic')
                    this.$store.commit('set_contract_id', params.row.id)
                  }
                }
              },
              '编辑'
            )
            const removeButton = h(
              'a',
              {
                style: {
                  color: 'red',
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '操作确认？',
                      content:
                        '<p>确定要删除合同【 ' +
                        params.row.name +
                        '】吗？</p>',
                      loading: true,
                      onOk: () => {
                        deleteContract({
                          contractId: params.row.id
                        })
                          .then((res) => {
                            if (res && !res.errcode) {
                              this.$Notice.success({ desc: '操作成功' })
                              this.initPageData()
                            }
                            this.$Modal.remove()
                          })
                          .catch((error) => {
                            this.$Modal.remove()
                            this.$Notice.error({
                              title: '服务器请求错误',
                              desc: error
                            })
                          })
                      }
                    })
                  }
                }
              },
              '删除'
            )

            const changeButton = h(
              'a',
              {
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$store.commit('set_contract_pageType', 'change')
                    this.$store.commit('set_contract_id', params.row.id)
                  }
                }
              },
              '合同变更'
            )

            const returnBtns = [detailButton]
            if (params.row.status === 1) {
              returnBtns.push(editButton)
              returnBtns.push(removeButton)
            }

            if (params.row.status === 6) { // 合同交付中，可以申请提交合同变更
              returnBtns.push(changeButton)
            }

            return h('div', returnBtns)
          }
        }
      ]
    }
  },
  created () {
    this.initPageData()
    // 获取状态清单
    listDictLabel({ dictType: 'contract_status' }).then(res => {
      this.statusArray = res
    })
  },
  methods: {
    initPageData () {
      this.tableLoading = true

      this.query.startDate = this.query.startDate ? ParseDate(this.query.startDate) : null
      this.query.endDate = this.query.endDate ? ParseDate(this.query.endDate) : null
      listContractInfo(this.query).then((response) => {
        this.total = response.totalRow
        this.tableData = response.list
        this.query.pageNumber = response.pageNumber
        this.tableLoading = false
      })
    },
    changePage (currentPage) {
      this.query.pageNumber = currentPage
      this.initPageData()
    },
    SearchData () {
      this.query.pageNumber = 1
      this.initPageData()
    },
    handleCreateInvestment () {
      // this.$store.commit('set_contract_id', null)
      // this.$store.commit('set_contract_pageType', 'create')
      // this.investmentCreateModal = true
      this.$refs.CreateContractModal.showModal()
    },
    handleCreateInvestemnt () {
      this.$refs.investmentCreate.handleSubmit()
      this.deviceAddModal = false
    },
    handleExportContract () {
      const filename = '招商合同清单(' + ParseDate(new Date()) + ').xlsx'

      const params = {
        startDate: this.query.startDate ? ParseDate(this.query.startDate) : null,
        endDate: this.query.endDate ? ParseDate(this.query.endDate) : null,
        queryString: this.query.queryString,
        status: this.query.status
      }

      downloadFileRequest(process.env.VUE_APP_API_URL_V2 + '/ooh-invest/v1/contract/exportContractInfo', params, filename)
    }
  },
  watch: {
    beginUpdate () {
      this.initPageData()
    }
  },
  computed: {
    beginUpdate () {
      return this.$store.state.investmentContract.beginUpdate
    }
  }
}
</script>
